import MarkdownIt from 'markdown-it';

// Our custom flavor of Markdown. Configured to be using Github Flavored Markdown.
// NOTE: If you change this, remember to update Redcarpet's configs accordingly.
// Look for them in the ruby markdown helper.
export default new MarkdownIt({
  // Tables and strikethrough (GFM) and Redcarpet's `no_intra_emphasis`,
  // `space_after_header` and `fenced_code_block` are enabled by default
  html: true,
  breaks: true,
  linkify: true, // Similar to Redcarpet's autolink
});

export const markdownWithoutHTML = new MarkdownIt({
  html: false,
  breaks: true,
  linkify: true,
});
